import { clsx } from 'clsx';
import Text from '~/components/typographies/Text';
import { Company } from '~/types/company';
import styles from './CompanyAvatar.module.scss';

interface CompanyAvatarProps {
  company: Company;
  round?: boolean;
}

const CompanyAvatar = ({ company, round }: CompanyAvatarProps) => {
  const { name } = company;
  const logo = company.logoUrls.small;
  const words = name.split(' ');

  const computedContainerClassName = clsx(styles.container, { [styles.withLogo!]: logo, [styles.round!]: round });

  return (
    <div className={computedContainerClassName}>
      {logo ? (
        <img src={logo} alt="" className={styles.logo} />
      ) : (
        <>
          {round ? (
            <Text variant="tiny" weight="bold" className={styles.label}>
              {words.length === 1 && name.substring(0, 2)}
              {words.length > 1 && `${words[0]?.charAt(0)}${words[1]?.charAt(0)}`}
            </Text>
          ) : (
            <Text variant="body2" weight="semibold" className={styles.label}>
              {words.length === 1 && name.substring(0, 2)}
              {words.length > 1 && `${words[0]?.charAt(0)}${words[1]?.charAt(0)}`}
            </Text>
          )}
        </>
      )}
    </div>
  );
};

export default CompanyAvatar;
